import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

const convertToRoman = (num) => {
  const romanNumerals = [
    { value: 1000, symbol: "M" },
    { value: 900, symbol: "CM" },
    { value: 500, symbol: "D" },
    { value: 400, symbol: "CD" },
    { value: 100, symbol: "C" },
    { value: 90, symbol: "XC" },
    { value: 50, symbol: "L" },
    { value: 40, symbol: "XL" },
    { value: 10, symbol: "X" },
    { value: 9, symbol: "IX" },
    { value: 5, symbol: "V" },
    { value: 4, symbol: "IV" },
    { value: 1, symbol: "I" },
  ];

  let result = "";
  for (let i = 0; i < romanNumerals.length; i++) {
    while (num >= romanNumerals[i].value) {
      result += romanNumerals[i].symbol;
      num -= romanNumerals[i].value;
    }
  }
  return result;
};

const convertNumberStringToRoman = (numString, delimiter) => {
  const regex = /(\d+)([^\d]*)/g;
  let result = "";
  let match;

  while ((match = regex.exec(numString)) !== null) {
    const num = parseInt(match[1]);
    result += convertToRoman(num) + delimiter;
  }

  // Xóa dấu phân cách cuối cùng nếu có
  return result.endsWith(delimiter) ? result.slice(0, -1) : result;
};

const NumberStringToRomanConverter = () => {
  const [inputNumberString, setInputNumberString] = useState("");
  const [romanString, setRomanString] = useState("");
  const [delimiter, setDelimiter] = useState(".");

  useEffect(() => {
    if (inputNumberString) {
      setRomanString(convertNumberStringToRoman(inputNumberString, delimiter));
    } else {
      setRomanString("");
    }
  }, [inputNumberString, delimiter]);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    Swal.fire({
      icon: "success",
      title: "Sao chép thành công!",
      text: "Thông báo bởi Webdio.",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });
  };

  return (
    <div className="min-h-screen flex flex-col items-center py-8 px-4 bg-gray-50 text-gray-900">
      <h1 className="text-3xl font-bold mb-4">Chuyển Đổi Chữ La Mã</h1>
      <div className="shadow-lg rounded-lg p-6 w-full max-w-4xl bg-white">
        <label
          htmlFor="inputText"
          className="block text-lg font-medium mb-2"
        >
          Nhập chuỗi số (vd: 2.3.2003, 4-3-2004, 3/4/2024):
        </label>
        <input
          type="text"
          id="inputNumberString"
          className="w-full border rounded-lg p-3 text-lg bg-gray-100 border-gray-300 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Ví dụ: 2.3.2003"
          value={inputNumberString}
          onChange={(e) => setInputNumberString(e.target.value)}
        />
        <div className="w-full flex justify-start left-0 mt-4 space-x-3">
          <button
            onClick={() => setDelimiter(".")}
            className={`px-4 py-2 rounded ${
              delimiter === "." ? "bg-blue-500 text-white" : "bg-gray-200 hover:bg-blue-500"
            }`}
          >
            Dấu "."
          </button>
          <button
            onClick={() => setDelimiter("-")}
            className={`px-4 py-2 rounded ${
              delimiter === "-" ? "bg-blue-500 text-white" : "bg-gray-200 hover:bg-blue-500"
            }`}
          >
            Dấu "-"
          </button>
          <button
            onClick={() => setDelimiter("/")}
            className={`px-4 py-2 rounded ${
              delimiter === "/" ? "bg-blue-500 text-white" : "bg-gray-200 hover:bg-blue-500"
            }`}
          >
            Dấu "/"
          </button>
        </div>
      </div>
      <div className="mt-6 w-full max-w-4xl">
        <h2 className="text-xl font-bold mb-4">Kết quả chuyển đổi sang La Mã</h2>
        <div className="p-4 rounded-lg shadow bg-gray-100">
          <div className="relative">
            <pre className="overflow-y-auto max-h-24 p-3 border rounded whitespace-pre-wrap font-sans font-bold text-lg bg-white border-gray-300 text-black">
              {romanString || <span className="loading loading-dots loading-xs"></span>}
            </pre>
            <button
              onClick={() => handleCopy(romanString)}
              className="absolute top-2 right-2 text-blue-500 hover:text-blue-700"
            >
              Sao chép
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NumberStringToRomanConverter;
